
<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Ticket Creation Details</h4>
        
      </div>
       <!-- <div class="mb-3 text-center">
    <button class="btn btn-success me-2" (click)="GetOnboardingGrid()">
      <i class="fa fa-eye me-1"></i> Onboarding Data
    </button>
    <button class="btn btn-primary me-2" (click)="GetOffboardingGrid()">
      <i class="fa fa-file-excel me-1"></i> Offboarding Data
    </button>
    </div> -->
       <!-- <button type="submit" class="btn btn-submit" (click)="GetOnboardingGrid()" >Onboarding Data</button>
        <button type="submit" class="btn btn-reject" (click)="GetOffboardingGrid()" >Offboarding Data</button>-->
      <!-- Employee Table -->
       <div class="row mb-4">
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Emp Code</th>
            <th>Mail ID</th>
            <th>Department</th>
            <th>Source</th>
            <th>Request Type</th>
            <th>Status</th>
            <th>Priority</th>
            <th>Subject</th>
            
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.ticketcreationdata; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1" ([ngModel])="appservice.ticketcreationid" (click)="editEmployee(emp.TR_iid)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  </div>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.TR_Employeeid }}</td>
            <td>{{ emp.TR_RequesterMailid }}</td>
            <td>{{ emp.TR_Department }}</td>
            <td>{{ emp.TR_Source }}</td>
            <td>{{ emp.TR_Type }}</td>
            <td>{{ emp.TR_Status }}</td>
            <td>{{ emp.TR_Priority }}</td>
            
            <td>{{ emp.TR_subject }}</td>
           
          </tr>
        </tbody>
      </table>
</div>
</div>
    
  </div>
</div>
